module.exports = __webpack_public_path__ + "bw.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bw.svg
// module id = 726
// module chunks = 0